export default "__VITE_PUBLIC_ASSET__555d030e__"